import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getWalletsDirectory } from '../walletsDirectoryEndpoints'
import { walletsDirectoryKeys } from '../walletsDirectoryQueryKeys'
import type { GetWalletsDirectoryParams } from '../../types/walletsDirectoryTypes'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10

export function useWalletsDirectoryListQuery(
  filters: MaybeRefOrGetter<Partial<GetWalletsDirectoryParams>>,
) {
  return useQuery({
    queryKey: () => walletsDirectoryKeys.list(toValue(filters)),
    queryFn: () =>
      getWalletsDirectory({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
        ...toValue(filters),
      }),
    placeholderData: keepPreviousData,
  })
}
